<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：插件中心-限时拼团-活动列表-修改活动
      -->
  <div>
    <div>
      <el-form size="small" ref="form" :model="form" label-width="150px">
        <!--基础设置-->
        <Basic :form="form"></Basic>

        <!--时间设置-->
        <Datetime :form="form"></Datetime>


        <!--其它-->
        <Other :form="form"></Other>
      </el-form>
    </div>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import TaskApi from '@/api/task.js';
import Basic from './part/Basic.vue';
import Datetime from './part/Datetime.vue';

import Other from './part/Other.vue';
import {mergeTable} from '@/utils/table.js'
export default {
  components: {
    /*基础设置*/
    Basic,
    /*时间设置*/
    Datetime,

    /*其它*/
    Other
  },
  data() {
    return {
      form: {
        step_points: [],
          task_id:'',
        /*任务名称*/
         task_name: '',
         /*广告图片ID*/
         image_id: 0,
         /*活动步数*/
         step_count:0,
         /*任务广告图*/
         file_path:'',
         video_id:0,
         /*任务时间*/
         active_time: '',
         /*是否生效，默认1为生效，0为不生效*/
         status: 1,
         /*任务类型 10 单人活动 20 团队活动*/
         task_type: 10,
         /*是否开启计步0否1是*/
         is_step: 0,
         /*默认排序*/
         sort: 100,
         /*是否投票 1 是 0 否*/
         is_vote:0,
        isVideo:true,
        video_path:'',
        video_msg:'',
        title_msg:'',
        unit_type:1,//单位类型 1 个 2 秒
      },
      /*判断是否正在加载*/
      loading: false,
    };
  },
  created() {
    this.form.task_id = this.$route.query.task_id;
    this.getData();
  },
  methods: {

    /*获取编辑数据*/
    getData() {
      let self = this;
      self.loading = true;
      TaskApi.toEditTask(
        {
          task_id: self.form.task_id
        },
        true
      )
        .then(res => {

          let tempForm=res.data.detail;
          tempForm.task_id = self.form.task_id;
          if(tempForm.video_path){
            tempForm.isVideo = true;
          }
          self.form=tempForm;
          console.log(self.form);
          self.loading = false;

        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if(valid) {

          let params = self.form;

          self.loading = true;
          TaskApi.editTask(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，修改成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });

    },



    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/task/task/edit.vue